module.exports = __webpack_public_path__ + "static/media/g7.96e4f8de.jpg";